import React from 'react';
import '../../../../../sass/apps/commerce/desktop/upgrade_information_content/faq.scss';

const FAQ = () => (
  <div className="faq">
    <h2>Questions about Bold Advertising</h2>
    <dl className="deflist">
      <dt className="faq__question">
        Will my ad always be at the top of the listings?
      </dt>
      <dd>
        Once you{`'`}ve upgraded you can keep your ad near the top by clicking
        renew on the My Ads page. Please note that if you don{`'`}t regularly
        click renew, your ad will start to fall down the listings and eventually
        drop off (after 28 days)
      </dd>

      <dt className="faq__question">When will my ad be made bold?</dt>
      <dd>
        Almost immediately! Your account is automatically updated. You should
        allow up to one hour for the site listings to update and show your
        ad as bold.
      </dd>

      <dt className="faq__question">
        Will I be charged again when the period expires?
      </dt>
      <dd>
        NO! We do not automatically rebill you for your bold advertising or
        access. We will send you an email just before it expires offering you
        the chance to renew it (you will have to enter your payment details
        again).
      </dd>

      <dt className="faq__question">
        What{`'`}s the difference between {`'`}Early Bird{`'`} and {`'`}Bold
        Advertising{`'`}?
      </dt>
      <dd>
        Essentially they are the same thing. If you buy one you automatically
        get the other. Early Bird entitles you to one bold ad and Bold
        Advertising comes with Early Bird thrown in.
      </dd>
    </dl>

    <h2>Questions about Early Bird access (included)</h2>
    <dl className="deflist">
      <dt className="faq__question">When will my access start?</dt>
      <dd>Immediately!</dd>
      <dt className="faq__question">
        Is the upgrade for a time period or {`'`}per ad{`'`}
      </dt>
      <dd>
        Time period – you pay once and then you can contact unlimited ads
        until the access expires
      </dd>

      <dt className="faq__question">
        Does the other user also need to be an Early Bird to receive my message?
      </dt>
      <dd>No</dd>
    </dl>
  </div>
);

export default FAQ;
